import o from "./atoms-v21283.js";
import t from "./atoms-v21284.js";
import a from "./atoms-v21285.js";
import r from "./atoms-v21286.js";
import e from "./atoms-v21287.js";
var c = {
  code: "en-US",
  formatDistance: o,
  formatLong: t,
  formatRelative: a,
  localize: r,
  match: e,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
export {
  c as default
};
